import { api } from "./client";

// Системни id-та — забранени за редакция/изтриване
export const SYSTEM_PAYMENT_METHOD_IDS: ReadonlySet<number> = new Set([
  1, 2, 3, 4,
]);

export const isSystemPaymentMethod = (id: number) =>
  SYSTEM_PAYMENT_METHOD_IDS.has(id);

export interface PaymentMethod {
  id: number;
  name_bg: string;
  name_en: string;
  sort_index: number;
}

export interface PaymentMethodCreatePayload {
  name_bg: string;
  name_en: string;
  sort_index?: number;
}

// Patch-style update — за protected методи (id ∈ {1..4}) пращай само { sort_index }
export type PaymentMethodUpdatePayload = Partial<{
  name_bg: string;
  name_en: string;
  sort_index: number;
}>;

// Извличане на всички начини на плащане — GET /payment-methods
// Бекендът връща записите вече сортирани по sort_index, id — не пресортирай.
export const getPaymentMethods = async (): Promise<PaymentMethod[]> => {
  const response = await api.get<PaymentMethod[]>("/payment-methods");
  return response.data;
};

// Активните начини на плащане за текущата сесия — GET /payment-methods/active
// Връща само методите, които имат стойност в device_payment_methods за
// device-а на сесията (резолва се на бекенда — shared/personal logic).
// Същата структура като /payment-methods.
export const getActivePaymentMethods = async (): Promise<PaymentMethod[]> => {
  const response = await api.get<PaymentMethod[]>(
    "/payment-methods/active",
  );
  return response.data;
};

// Създаване на нов начин на плащане — POST /payment-methods
export const createPaymentMethod = async (
  data: PaymentMethodCreatePayload,
): Promise<PaymentMethod> => {
  const response = await api.post<PaymentMethod>("/payment-methods", data);
  return response.data;
};

// Редакция на начин на плащане — PUT /payment-methods/:id
export const updatePaymentMethod = async (
  id: number,
  data: PaymentMethodUpdatePayload,
): Promise<PaymentMethod> => {
  const response = await api.put<PaymentMethod>(
    `/payment-methods/${id}`,
    data,
  );
  return response.data;
};

// Изтриване на начин на плащане — DELETE /payment-methods/:id
export const deletePaymentMethod = async (id: number): Promise<void> => {
  await api.delete(`/payment-methods/${id}`);
};
